import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMoodleV2 } from "../../../contexts/moodle";
import DownloadIcon from '@mui/icons-material/Download';
import { useTheme } from "../../../contexts/ThemeContext";
import { readableColor } from "polished";

export const ProgressRowItem = ({ course, grade, lang, includeEncuesta }) => {
  const navigation = useNavigate();
  const moodlev2 = useMoodleV2();
  const theme = useTheme();
  const [contrastColor, setContrastColor] = React.useState("#fff");

  const [data /* setData */] = React.useState({
    name: course.displayname,
    start: new Date(course.startdate * 1000).toLocaleDateString(),
    end:
      course.enddate !== 0
        ? new Date(course.enddate * 1000).toLocaleDateString()
        : "Sin fecha de termino",
  });
  const [certificadoAvailable, setCertificadoAvailable] = React.useState(null);

  useEffect(() => {
    const fetchCerts = async () => {
      let courseContent = await moodlev2.getCourseContentByID(course.id);
      // recorrer el course content y buscar el modulo que tenga certificado
      courseContent.modules && courseContent.modules.forEach((module) => {
        if (module.modules && module.modules.length > 0) {
          module.modules.forEach((submodule) => {
            // si el modulo tiene el prefijo cert y es visible para el usuario
            if (submodule.name.toLowerCase().startsWith("cert - envi") && submodule.uservisible) {
              console.log(submodule)
              setCertificadoAvailable(`${submodule.url}&downloadown=1`);
            }
          })
        }
      })
    }
    fetchCerts()
  }, [course.id]);

  useEffect(() => {
    if (theme && theme.colors?.background_primary) {
      if (theme.mode === "light") {
        setContrastColor("#232323");
      } else {
        setContrastColor(readableColor(theme.colors?.background_primary?.backgroundColor));
      }
    }
    //console.log(contrastColor)
  }, [theme, contrastColor]);

  const handleDetailNavigation = () =>
    navigation(`/listcourses/progress/${course.id}`, {
      state: { name: data.name },
    });

  const handleCourseNavigation = async () => {
    if(certificadoAvailable){
      window.location.href = certificadoAvailable;
    }
    /* navigation(`/detailcourse/${course.id}`, {
      state: { name: data.name },
    }); */
    // recorrer el course content y buscar el modulo que tenga certificado
  }

  return (
    <>
      <tr
      // className="hover:bg-slate-100"
      >
        <th
          onClick={handleDetailNavigation}
          scope="row"
          className="p-4 border-b cursor-pointer border-slate-200 hover:!text-red-800 transition-colors"
          style={{
            borderColor: theme.colors.backgroundColorNotCurrentModule,
          }}
        >
          <p style={{ color: theme.colors.textColorDefault }}>{data.name}</p>
        </th>
        <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule, }}>{grade}</td>
        {/* <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule, }}>{data.start}</td> */}
        {/* <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule, }}>
          {data.end === "Sin fecha de termino"
            ? lang["History"].fourth_column_answer
            : data.end}
        </td> */}
        <td className={`p-4 border-b border-slate-200 ${certificadoAvailable && 'hover:bg-red-800'}`} style={{ cursor: certificadoAvailable ? 'pointer' : 'default', fontWeight: certificadoAvailable ? 700 : 500, borderColor: theme.colors.backgroundColorNotCurrentModule, }} onClick={handleCourseNavigation}>
          {certificadoAvailable && <DownloadIcon />}
          {certificadoAvailable ? lang["History"].fifth_column_answer : '-'}
        </td>
        {includeEncuesta && <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule, }}> - {/* {lang["History"].sixth_column_answer} */}</td>}
      </tr>
    </>
  );
};
